<template>
  <div id="removeItemsModal">
    <b-modal
      id="confirmModal"
      v-model="removeItemsModal.show"
      :title="removeItemsModal.title"
      body-class="p-0"
      @show="onShow"
    >
      <no-content :show="items.length === 0" />
      <content-spinner :show="removeItemsModal.loading" />
      <b-table
        v-if="items.length > 0 && !removeItemsModal.loading"
        responsive="sm"
        class="sticky-header"
        :items="items"
        :fields="getFields"
        :responsive="true"
        :no-local-sorting="true"
      >
        <template #cell(action)="row">
          <b-button
            v-if="isEdit"
            size="sm"
            variant="outline-primary"
            class="mr-2"
            @click="edit(row.item)"
          >
            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
          </b-button>
          <b-button
            v-else
            size="sm"
            variant="outline-danger"
            class="mr-2"
            :disabled="selectedItems.length > 0"
            @click="remove(row.item)"
          >
            <font-awesome-icon :icon="['fas', 'times']" />
          </b-button>
        </template>
        <template #cell(select)="{item, index, field}">
          <b-checkbox v-model="item[field.key]" />
        </template>
      </b-table>
      <template #modal-footer="{ok}">
        <b-button
          v-if="selectedItems.length > 0"
          variant="danger"
          class="mr-2"
          @click="onDeleteClick"
        >
          Delete
        </b-button>
        <b-button
          variant="primary"
          @click="ok"
        >
          OK
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import NoContent from '../../core/components/NoContent';
import ContentSpinner from '../../core/components/ContentSpinner';

const {mapState, mapActions} = createNamespacedHelpers('sunModel');

export default {
  name: 'RemoveItemsModal',
  components: {ContentSpinner, NoContent},
  props: {
    removeModal: {
      show: Boolean,
      title: String,
      items: Array,
      fields: Array,
    },
  },
  data() {
    return {
      actionColumn: 'action',
      items: [],
      fields: [],
    };
  },
  watch: {
    removeItemsModal() {
      this.initialData();
    },
  },
  computed: {
    ...mapState({
      removeItemsModal: state => state.sunModel.removeItemsModal,
    }),
    getFields() {
      const fields = [...this.fields];
      fields.push('action');
      if (!this.isEdit) {
        fields.unshift({key: 'select', label: '', thStyle: {width: '10px'}});
      }
      return fields;
    },
    isEdit() {
      return this.removeItemsModal.isEdit;
    },
    selectedItems() {
      return this.items.filter(item => item.select);
    },
  },
  methods: {
    remove(item) {
      if (this.removeItemsModal.callback) {
        this.removeItemsModal.callback(item);
      }
    },
    edit(item) {
      if (this.removeItemsModal.callback) {
        this.removeItemsModal.callback(item);
      }
    },
    onDeleteClick() {
      if (this.removeItemsModal.callback) {
        this.removeItemsModal.callback(this.selectedItems);
      }
    },
    onShow() {
      this.initialData();
    },
    initialData() {
      this.items = JSON.parse(JSON.stringify(this.removeItemsModal.items));
      this.fields = JSON.parse(JSON.stringify(this.removeItemsModal.fields));
    },
  },
};
</script>

<style lang="scss">
#removeItemsModal {
  /deep/ .lobi-spinner {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    z-index: 1;
  }

  .expand-button {
    display: block;
    margin: 0 auto;
  }

  .red {
    color: red;
  }
}
</style>